document.addEventListener("DOMContentLoaded", () => {
  const categoryListBlock = document.querySelector(".category-list-block");

  if (categoryListBlock) {
    const url = window.location.href;
    const http = url.split("//");
    const websiteTitle = http[1].split("/");
    const urlAux = url.split(http[0] + "//" + websiteTitle[0] + "/");
    const categoryUrl = urlAux[1];

    document
      .querySelectorAll(".category-list-block .views-row a.bike-category")
      .forEach((element) => {
        const href = element.getAttribute("href");
        const relativeUrl = "/" + categoryUrl,
          absoluteUrl = "https://www.blazingsaddles.com/" + categoryUrl;

        if (href == relativeUrl || href == absoluteUrl) {
          element.closest(".views-row").classList.add("active");
        } else {
          element.closest(".views-row").classList.remove("active");
        }
      });

    const blockTitle = categoryListBlock.querySelector(".block-title");

    if (blockTitle) {
      blockTitle.parentNode.removeChild(blockTitle);

      categoryListBlock
        .querySelector(".content")
        .insertBefore(
          blockTitle,
          categoryListBlock.querySelector(".content").firstChild
        );
    }

    if (!categoryListBlock.querySelector(".category-popup-close")) {
      categoryListBlock
        .querySelector(".block-title")
        .insertAdjacentHTML(
          "afterend",
          "<div class='category-popup-close'></div>"
        );
    }

    let categorySelector = categoryListBlock.querySelector(
      ".category-selector.popup-link"
    );

    if (!categorySelector) {
      let activeCategory = categoryListBlock.querySelector(
        ".category-list-block .views-row.active"
      );
      let categoryName = activeCategory
        ? activeCategory.querySelector(".category-name").textContent
        : "Select Category";
      let categorySelectorHtml =
        '<div class="category-selector popup-link" target=".category-list-block"><div>Category: ' +
        categoryName +
        "</div></div>";
      document
        .querySelector("#main .sidebar-left")
        .insertAdjacentHTML("afterbegin", categorySelectorHtml);
    }

    categoryListBlock.addEventListener("click", function (event) {
      if (!event.target.closest(".content")) {
        /* document.body.style.overflow = 'auto'; */
        categoryListBlock.classList.remove("opened");
        document.body.classList.remove("category-popup-opened");
      }
    });

    let popupLink = document.querySelector(".popup-link");

    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    popupLink.addEventListener("click", function (e) {
      /* document.body.style.overflow = 'hidden'; */
      e.preventDefault();

      let theViewportHeight = window.innerHeight;
      let target = popupLink.getAttribute("target");

      document.querySelector(target).classList.add("opened");

      if (window.innerWidth <= 768) {
        /* if (isSafari) {
          categoryListBlock.style.height = theViewportHeight + "px";
          categoryListBlock.querySelector(".category-list").style.height =
            theViewportHeight - 50 + "px";
          categoryListBlock.querySelector(".view-categories").style.height =
            theViewportHeight - 50 + "px";
        } */
      }

      document.body.classList.add("category-popup-opened");

      if (e.target.closest(".one-bike")) {
        // pre-fill bike name inside the form's bike input field.
        let bikeName = e.target
          .closest(".one-bike")
          .querySelector(".bike-name").textContent;
        document.getElementById("edit-bike").value = bikeName;
      }
    });

    document
      .querySelector(".category-popup-close")
      .addEventListener("click", function () {
        /* document.body.style.overflow = 'auto'; */
        categoryListBlock.classList.remove("opened");
        document.body.classList.remove("category-popup-opened");
        document.body.classList.remove("webform-popup-opened");

        if (window.innerWidth <= 768) {
          if (isSafari) {
            categoryListBlock.style.height = "0";
          }
        }
      });

    const categoryLinks = document.querySelectorAll(
      ".category-list-block .views-row a"
    );

    categoryLinks.forEach(function (element) {
      element.addEventListener("click", function () {
        categoryListBlock.classList.remove("opened");
        document.body.classList.remove("category-popup-opened");
      });
    });
  }
});
